// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__LiDyd","tyre":"style_tyre__4iXCp"};